// 'PersistentState' has to be initialized as first module to have priority in listening hooks
import PersistentState from './persistentState/persistentState';
import AutoColumnSize from './autoColumnSize/autoColumnSize';
import AutoFill from './autofill/autofill';
import AutoRowSize from './autoRowSize/autoRowSize';
import ColumnSorting from './columnSorting/columnSorting';
import Comments from './comments/comments';
import ContextMenu from './contextMenu/contextMenu';
import CopyPaste from './copyPaste/copyPaste';
import CustomBorders from './customBorders/customBorders';
import DragToScroll from './dragToScroll/dragToScroll';
import ManualColumnFreeze from './manualColumnFreeze/manualColumnFreeze';
import ManualColumnMove from './manualColumnMove/manualColumnMove';
import ManualColumnResize from './manualColumnResize/manualColumnResize';
import ManualRowMove from './manualRowMove/manualRowMove';
import ManualRowResize from './manualRowResize/manualRowResize';
import MergeCells from './mergeCells/mergeCells';
import MultipleSelectionHandles from './multipleSelectionHandles/multipleSelectionHandles';
import ObserveChanges from './observeChanges/observeChanges';
import Search from './search/search';
import TouchScroll from './touchScroll/touchScroll';
import UndoRedo from './undoRedo/undoRedo';
import Base from './_base';
import BindRowsWithHeaders from './bindRowsWithHeaders/bindRowsWithHeaders';
import CollapsibleColumns from './collapsibleColumns/collapsibleColumns';
import ColumnSummary from './columnSummary/columnSummary';
import DropdownMenu from './dropdownMenu/dropdownMenu';
import ExportFile from './exportFile/exportFile'; // 'MultiColumnSorting' must be initialized before Filters. Bug releated with "wrong listeners order" attached to 'modifyRow' and 'unmodifyRow' hooks.

import MultiColumnSorting from './multiColumnSorting/multiColumnSorting';
import Filters from './filters/filters';
import Formulas from './formulas/formulas';
import GanttChart from './ganttChart/ganttChart';
import HeaderTooltips from './headerTooltips/headerTooltips';
import NestedHeaders from './nestedHeaders/nestedHeaders';
import NestedRows from './nestedRows/nestedRows'; // 'HiddenColumns' must be initialized after NestedHeaders. Bug releated with wrong listeners order attached to 'modifyColWidth' hook.

import HiddenColumns from './hiddenColumns/hiddenColumns';
import HiddenRows from './hiddenRows/hiddenRows';
import TrimRows from './trimRows/trimRows';
export { AutoColumnSize, AutoFill, AutoRowSize, Base, BindRowsWithHeaders, CollapsibleColumns, ColumnSorting, ColumnSummary, Comments, ContextMenu, CopyPaste, CustomBorders, DragToScroll, DropdownMenu, ExportFile, Filters, Formulas, GanttChart, HeaderTooltips, HiddenColumns, HiddenRows, ManualColumnFreeze, ManualColumnMove, ManualColumnResize, ManualRowMove, ManualRowResize, MergeCells, MultiColumnSorting, MultipleSelectionHandles, NestedHeaders, NestedRows, ObserveChanges, PersistentState, Search, TouchScroll, TrimRows, UndoRedo };


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/index.js
// module id = 19n3
// module chunks = 0